// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled, {css} from 'styled-components';
import createDebugger from 'debug';
import {Collapse} from './PureCollapse';
const debug = createDebugger('app:components:CollapsingContainer'); // eslint-disable-line no-unused-vars
import {
  Icon,
  IconLookup,
} from 'trustar-2.0/components';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';

// Style
const StyledCollapsingContainer = styled.div`
  display: inline-block;
  width: ${({theme, stretched}) => stretched ? '100%' : theme.Widths.FILTER_BOX};
  margin-top: 1.25rem;
  background-color: ${({theme, backgroundColor}) => backgroundColor ? backgroundColor : theme.ThemeColors.SURFACE_LIGHTER.hex};
  position: relative;
  margin-bottom: 0.25rem;
  
  :before {
    content: '';
    height: 0.55rem;
    border-radius: 100px;
    background-color: ${({theme}) => theme.ThemeColors.PRIMARY.hex};
    width: 0.55rem;
    display: block;
    position: absolute;
    opacity: ${props => props.active ? '0.5' : '0'};
    top: calc(50% - 0.275rem);
    left: 0.5rem;
    }
  
  ${props => props.disabled && css`
    pointer-events: none;
    background-color: ${({theme}) => theme.ThemeColors.SURFACE.hex};
    opacity: 0.65;
  `
  }
`;

const StyledTitle = styled.h3`
  display: flex;
  justify-content: space-between;
  padding: 1.1rem 1.1rem 1.1rem 1.5rem;
  cursor: pointer;
  margin: 0;
  font-size: ${({theme}) => theme.FontSizes.H3};
  user-select: none;
 
`;

const initialValues = {
  isOpen: false,
  theme: DefaultTheme,
};

// Bindings
type CollapsingContainerProps = {
  isOpen?: boolean,
  children: React.Element<*>,
  title: string,
  numberSelected?: string | number,
  active?: boolean,
  disabled?: boolean,
  theme: ThemeType,
  doOnToggle?: Function,
  stretched?: boolean,
  backgroundColor?: string,
  className?: string,
};

class CollapsingContainer extends Component {
  props: CollapsingContainerProps;
  static defaultProps = initialValues;
  state = {
    isOpen: this.props.isOpen || initialValues.isOpen
  };

//  ----Template----

  render() {
    return (
      <StyledCollapsingContainer className={`${this.props.className ? this.props.className : ''}`} disabled={this.props.disabled} active={this.props.active && !this.state.isOpen} stretched={this.props.stretched}>
        <StyledTitle isOpen={this.state.isOpen} onClick={this.toggle}> {this.props.title} {this.props.numberSelected ? `(${this.props.numberSelected})` : ''} <Icon icon={this.state.isOpen ? IconLookup.CHEVRON_UP : IconLookup.CHEVRON_DOWN} /> </StyledTitle>
        <Collapse isOpen={this.state.isOpen} >
          {this.props.children}
        </Collapse>
      </StyledCollapsingContainer>
    );
  }

// ----Lifecycle Hooks----

// ----Methods----

  toggle = (option: Object) => {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.props.doOnToggle) this.props.doOnToggle();
  };
}

// Logic & Helper Components
const options = [

];

// Connect To State
const mapStateToProps = (state) => ({
  isOpen: null // Some variable,
});

const dispatchProps = {
  methodOne: ()=>{}, // Some action
};

export default connect(mapStateToProps, dispatchProps)(CollapsingContainer);

export {CollapsingContainer};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/CollapsingContainer.js